import { render, staticRenderFns } from "./gc-split-view.vue?vue&type=template&id=63601722"
import script from "./gc-split-view.vue?vue&type=script&lang=js"
export * from "./gc-split-view.vue?vue&type=script&lang=js"
import style0 from "./gc-split-view.vue?vue&type=style&index=0&id=63601722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports